import { render } from "./Items.vue?vue&type=template&id=270132d7&scoped=true&ts=true"
import script from "./Items.vue?vue&type=script&lang=ts"
export * from "./Items.vue?vue&type=script&lang=ts"

import "./Items.vue?vue&type=style&index=0&id=270132d7&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-270132d7"]])

export default __exports__